import { animate, sequence, style, transition, trigger } from '@angular/animations';

export const listAnimation = trigger('listAnimation', [
  transition('void => *', [
    style({ height: '*', opacity: '0' }),
    sequence([animate('.35s ease', style({ height: '*', opacity: 1 }))]),
  ]),
]);
